import axios from "axios";
import Config from "../config";

const getRooms = (params) => {
    const {
        keyword = '', 
        created_at = [], 
        source = null, 
        channel_id = null, 
        status = 'all', 
        tag_ids = [], 
        linked_status = 'all',
        is_group = false,
        page = 1
    } = params;

    return axios({
        method: "POST",
        url: (Config.url || '') + "/api/v3/list-rooms",
        data: { page, keyword, created_at, source, channel_id, status, tag_ids, linked_status, is_group }
    });
};

export default getRooms;
